<template>
  <VSection large label="transactions.product_headline">
    <VSection label="transactions.content_headline" level="5">
      <VDescriptionListDivided>
        <VGroup label="transactions.content_information_headline">
          <VEntry :data="transactionDetails" field="contentCategory" name="transactions.content_category_label" />
          <VEntry :data="transactionDetails" field="contentCategoryDescription" name="transactions.content_category_description_label" />
          <VEntry :data="transactionDetails" field="contentType" name="transactions.content_type_label" />
          <VEntry :data="transactionDetails" field="contentTypeDescription" name="transactions.content_description_label" />
          <VEntry :data="transactionDetails" field="externalDescription" name="transactions.content_external_description_label" />
          <VEntry :data="transactionDetails" field="externalBookingID" name="transactions.content_external_booking_id_label" />
        </VGroup>
        <VGroup label="transactions.content_vas_headline">
          <VEntry :data="transactionDetails" field="vasCode" name="transactions.content_vas_code_label" />
          <VEntry :data="transactionDetails" field="vasCodeDescription" name="transactions.content_vas_code_description_label" />
          <VEntry :data="transactionDetails" field="vasGroup" name="transactions.content_vas_group_label" />
          <VEntry :data="transactionDetails" field="vasGroupDescription" name="transactions.content_vas_group_description_label" />
        </VGroup>
        <VGroup label="transactions.content_bookings_headline">
          <VEntry :data="transactionDetails" field="numberOfBookings" name="transactions.content_units_number_bookings_label" />
          <VEntry :data="transactionDetails" field="requestedUnits" name="transactions.content_units_requested_label" />
          <VEntry :data="transactionDetails" field="deliveredUnits" name="transactions.content_units_delivered_label" />
        </VGroup>
        <VGroup label="transactions.content_extensions_headline">
          <VEntry :data="transactionDetails" field="numberOfExtensions" name="transactions.content_extensions_number_label" />
          <VEntryDate :data="transactionDetails" field="firstExtension" name="transactions.content_extensions_first_extension_label" />
          <VEntryDate :data="transactionDetails" field="lastExtension" name="transactions.content_extensions_last_extension_label" />
        </VGroup>
      </VDescriptionListDivided>
    </VSection>

    <VSection label="transactions.subscription_headline" level="5">
      <VDescriptionListDivided>
        <VEntry :data="transactionDetails" field="subscriptionDataTemplateId" name="transactions.subscription_template_id_label" />
        <VEntry :data="transactionDetails" field="externalDescription" name="transactions.subscription_template_description_label" />
        <VEntry :data="transactionDetails" field="externalBookingID" name="transactions.subscription_template_external_booking_id_label" />
        <VEntry :data="transactionDetails" field="subscriptionDataProRating" name="transactions.subscription_template_pro_rating_label" boolean />
        <VEntry :data="transactionDetails" field="subscriptionDataPromotion" name="transactions.subscription_template_promotion_label" boolean />
        <VEntry :data="transactionDetails" field="subscriptionDataChargeType" name="transactions.subscription_template_charge_type_label" />
        <VEntryDate
          date
          :data="transactionDetails"
          field="subscriptionDataBeginOfChargingPeriod"
          name="transactions.subscription_template_charging_interval_start_label"
        />
        <VEntryDate
          :data="transactionDetails"
          field="subscriptionDataEndOfChargingPeriod"
          name="transactions.subscription_template_charging_interval_stop_label"
        />
        <VEntryDate :data="transactionDetails" field="subscriptionDataReferenceDate" name="transactions.subscription_template_reference_date_label" />
      </VDescriptionListDivided>
    </VSection>
  </VSection>
</template>

<script>
import VSection from '@/components/Section';
import VDescriptionListDivided from '@/components/DescriptionList/Divided';
import VGroup from '@/components/DescriptionList/Group';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';

export default {
  name: 'PaymentTransactionsDetailsProduct',

  components: {
    VSection,
    VDescriptionListDivided,
    VGroup,
    VEntry,
    VEntryDate,
  },

  props: {
    transactionDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>
